import Api from '@/services/API'

export default {
  livenessProbe () {
    return Api().get('/liveness')
  }
}



// WEBPACK FOOTER //
// ./src/services/APIService.js